module.exports = __webpack_public_path__ + "fe8a382429561d27a419b45fa30c3d4c.jpg";